export const Roll = Object.freeze({
  administrator: 'administrator',
  worker: 'worker',
  reader: 'reader'
})

export const viewId = Object.freeze({
  header: '00001',
  sideMenu: '00002',
  footer: '00003',
  subHeader: '00004',
  login: '00101',
  logout: '00102',
  home: '00201',
  humanCapitalBasicInfo: '10101',
  humanCapitalConfiguration: '10102',
  humanResourcesManagement: '10103',
  hiringAndOnboarding: '10104',
  developAndRetention: '10105',
  monthMonitoring: '10106',
  iso30414: '10107',
  dei: '10108',
  healthManage: '10109',
  legalDisclosure: '10110',
  kpi: '10111',
  kgi: '10112',
  fileUpload: '10201',
  taskList: '10202',
  analysisData: '10203',
  dataUpdateStatus: '10204',
  accountingData: '10205',
  notice: '10301',
  news: '10302',
  changePassword: '10401',
  userList: '10402',
  userPermission: '10403',
  privacyPolicy: '10501',
  tos: '10502',
  dashboardList: '10601',
  myDashboard: '10701',
  kpiTargetSetting: '10801',
  kgiList: '10901',
  businessPlanNew: '10902',
  businessPlanEdit: '10903',
  authorityGroupList: '11001',
  authorityGroupInfo: '11002',
  benchmarkTargetList: '11101',
  benchmarkTargetInfo: '11102',
  masterList: '11201',
  segmentInfo: '11202',
  newGraduateInfo: '11203',
  recruitmentPlanInfo: '11204',
  absenceRateInfo: '11205',
  hierarchyInfo: '11206',
  associationInfo: '11207',
  certificationInfo: '11208',
  certificationSet: '11209',
  groupCompanyInfo: '11210',
  securitiesReportInfo: '11212',
  employeeCountInfo: '11213',
  annualIncomeCalculationInfo: '11214',
  statutoryDisclosure: '11215',
  categoryInfo: '11216',
  companyInfo: '11217',
  depInfoHierarchySetting: '11218',
  conversionTableInfo: '11219',
  userClassificationInfo: '11221',
  chrofyClassificationInfo: '11222',
  judgmentRuleList: '11223',
  judgmentRuleSetting: '11224'
})

export const definedValue = Object.freeze({
  containerHeight: 500,
  footerHeight: 349
})

export const titleName = Object.freeze({
  common: ' | CHROFY HC',
  login: 'ログイン',
  notFound: 'ページが見つかりません',
  forbidden: 'アクセスできません',
  top: 'TOP',
  changePassword: 'パスワード変更',
  fileUpload: 'データアップロード',
  taskList: 'データ更新',
  analysisData: 'データマッピング・データ更新',
  accountingData: '財務データアップロード',
  dataUpdateStatus: 'データ更新状況',
  news: '人的資本関連ニュース一覧',
  notice: '運営からのお知らせ一覧',
  dashboardList: 'ダッシュボード一覧',
  myDashboard: 'マイダッシュボード',
  kpiSetting: '人的資本KPI目標設定',
  userList: 'ユーザー権限管理',
  userPermission: 'ユーザー権限設定',
  kgiList: '経営戦略KGI管理',
  kgiInfo: '経営計画設定',
  kgiSetInfo: '中期経営計画設定',
  authorityGroupList: '権限グループ管理',
  authorityGroupInfo: '権限グループ設定',
  benchmarkTargetList: 'ベンチマーク設定',
  benchmarkTarget: 'ベンチマーク設定の登録・編集',
  masterList: 'マスター管理',
  segmentInfo: 'セグメント設定',
  NewGraduateInfo: '新卒採用設定',
  RecruitmentPlanInfo: '採用予定人数設定',
  absenceRateInfo: '欠勤率設定',
  hierarchyInfo: '階層設定',
  associationInfo: '第1階層の経年紐づけ設定',
  certificationInfo: '資格マスター設定',
  certificationSet: '資格セット設定',
  groupCompanyInfo: 'グループ会社設定',
  employmentTypeInfo: '雇用区分マスター設定',
  employeeCountInfo: '人数カウント設定',
  AnnualIncomeCalculationInfo: '年収計算設定',
  statutoryDisclosure: '法定開示レポート設定',
  dataMapping: '汎用データマッピング',
  securitiesReport: '有価証券報告書レポート設定',
  classificationInfo: '区分マスター設定（ユーザー設定）',
  chrofyClassificationInfo: '区分マスター画面（CHROFY規定値）',
  categoryInfo: '用途タグ設定',
  companyInfo: '会社情報設定',
  depInfoHierarchySetting: '組織情報・組織階層設定',
  conversionTableInfo: '変換表設定',
  judgmentRuleList: '判定ルール一覧',
  judgmentRuleSetting: '判定ルール設定'
  /* privacyPolicy、TosはPathInfoListのStaticPageを参照 */
  /* ダッシュボードはPageInfoListのmainPageInfoListを参照 */
})

export const orderBy = Object.freeze({
  asc: 'asc',
  desc: 'desc'
})

export const removeDuplicates = Object.freeze({
  remove: 'Y',
  notRemove: 'N'
})

export const allConditions = Object.freeze({
  allBookmark: 'すべてブックマーク',
  allCategory: 'すべて用途タグ',
  allBadge: 'すべてバッジ'
})

export const table = Object.freeze({
  AnalysisTargetInfo: 'AnalysisTargetInfo',
  AnalysisCondition: 'AnalysisCondition',
  AppMaster: 'AppMaster',
  AuthorityGroup: 'AuthorityGroup',
  Bookmark: 'Bookmark',
  BusinessPlan: 'BusinessPlan',
  Category: 'Category',
  CategoryTag: 'CategoryTag',
  Company: 'Company',
  CompanyConfig: 'CompanyConfig',
  DataCreateTask: 'DataCreateTask',
  FileUploadTask: 'FileUploadTask',
  AccountingUploadTask: 'AccountingUploadTask',
  Kgi: 'Kgi',
  KgiSet: 'KgiSet',
  KpiActualInfo: 'KpiActualInfo',
  KpiTargetInfo: 'KpiTargetInfo',
  KpiTargetSubInfo: 'KpiTargetSubInfo',
  RelatedDashboard: 'RelatedDashboard',
  SearchCondition: 'SearchCondition',
  User: 'User',
  BenchmarkTarget: 'BenchmarkTarget',
  Master: 'Master',
  DepartmentHierarchy: 'DepartmentHierarchy',
  DepartmentInfo: 'DepartmentInfo',
  Certification: 'Certification',
  CertificationSet: 'CertificationSet',
  GenericMappingTemplate: 'GenericMappingTemplate',
  GenericDataMapping: 'GenericDataMapping',
  GenericUploadFile: 'GenericUploadFile',
  FileClassification: 'FileClassification',
  GroupCompanyInfo: 'GroupCompanyInfo',
  StandardFormatUsageItems: 'StandardFormatUsageItems',
  GenericUploadTask: 'GenericUploadTask',
  Segment: 'Segment',
  ValueConversion: 'ValueConversion',
  DataClassification: 'DataClassification',
  JudgmentRule: 'JudgmentRule'
})

export const analysisMode = Object.freeze({
  standalone: 'standalone',
  consolidated: 'consolidated'
})

export const restApiKey = Object.freeze({
  CHROFY_REST_API: 'CHROFY_REST_API',
  CHROFY_REST_API_COMMON: 'CHROFY_REST_API_COMMON'
})

export const companyConfig = Object.freeze({
  securitiesReport: 'SecuritiesReport'
})

export const operator = Object.freeze({
  GE: { name: '以上', value: 'GE' },
  LE: { name: '以下', value: 'LE' }
})

export const kpiUnit = Object.freeze({
  none: {
    name: '',
    numDecPlaces: 1
  },
  yen: {
    name: '円',
    numDecPlaces: 0
  },
  people: {
    name: '人',
    numDecPlaces: 0
  },
  hour: {
    name: '時間',
    numDecPlaces: 2
  },
  percent: {
    name: '%',
    numDecPlaces: 2
  },
  times: {
    name: '回',
    numDecPlaces: 1
  },
  items: {
    name: '件',
    numDecPlaces: 1
  }
})

export const kpiOperator = Object.freeze({
  none: '指定なし',
  more: '以上',
  less: '以下'
})

export const kgiUnit = Object.freeze({
  none: {
    name: '単位なし',
    numDecPlaces: 1
  },
  percent: {
    name: '%',
    numDecPlaces: 2
  },
  people: {
    name: '人',
    numDecPlaces: 0
  },
  times: {
    name: '回',
    numDecPlaces: 1
  },
  items: {
    name: '件',
    numDecPlaces: 1
  },
  hour: {
    name: '時間',
    numDecPlaces: 2
  },
  yen: {
    name: '円',
    numDecPlaces: 0
  },
  thousand_yen: {
    name: '千円',
    numDecPlaces: 0
  },
  milion_yen: {
    name: '百万円',
    numDecPlaces: 0
  },
  billion_yen: {
    name: '億円',
    numDecPlaces: 0
  }
})

export const kgiStatus = Object.freeze({
  none: {
    name: ''
  },
  tempRegist: {
    name: '仮登録'
  },
  release: {
    name: '公開'
  },
  secret: {
    name: '非公開'
  }
})
export const periodKind = Object.freeze({
  monthly: {
    name: '月次',
    value: 'monthly',
    unit: '月'
  },
  quarter: {
    name: '四半期',
    value: 'quarter',
    unit: '期'
  },
  year: {
    name: '年次',
    value: 'year',
    unit: '年度'
  }
})

export const taskStatus = Object.freeze({
  todo: {
    name: '作業待ち',
    value: 'todo'
  },
  doing: {
    name: '作業中',
    value: 'doing'
  },
  done: {
    name: '完了',
    value: 'done'
  }
})

export const dataCreateStatus = Object.freeze({
  uncreated: {
    name: 'アップロード待ち',
    value: 'uncreated'
  },
  await: {
    name: '更新待ち',
    value: 'await'
  },
  recreate: {
    name: '再更新待ち',
    value: 'recreate'
  },
  creating: {
    name: '更新中',
    value: 'creating'
  },
  created: {
    name: '更新済',
    value: 'created'
  },
  error: {
    name: '更新エラー',
    value: 'error'
  }
})

export const dataFixStatus = Object.freeze({
  fix: {
    name: '確定',
    value: 'fix'
  },
  pending: {
    name: '未確定',
    value: 'pending'
  }
})

export const operationKind = Object.freeze({
  create: {
    name: 'データ更新',
    value: 'create'
  },
  lock: {
    name: 'データ確定',
    value: 'lock'
  },
  unlock: {
    name: 'データ確定解除',
    value: 'unlock'
  }
})

export const fileUploadTaskStatus = Object.freeze({
  unregistered: {
    name: '未登録',
    value: 'unregistered'
  },
  'no-data': {
    name: 'データ無し',
    value: 'no-data'
  },
  checking: {
    name: 'チェック中',
    value: 'checking'
  },
  'check-ok': {
    name: 'チェック済',
    value: 'check-ok'
  },
  'check-ng': {
    name: 'チェックエラー',
    value: 'check-ng'
  }
})

export const accountingUploadTaskStatus = Object.freeze({
  unregistered: {
    name: '未登録',
    value: 'unregistered'
  },
  processing: {
    name: '処理中',
    value: 'processing'
  },
  registered: {
    name: '登録済',
    value: 'registered'
  },
  error: {
    name: 'エラー',
    value: 'error'
  }
})

export const listingClassification = Object.freeze({
  public: {
    name: '上場',
    value: '1'
  },
  private: {
    name: '非上場',
    value: '2'
  }
})

export const companySize = Object.freeze({
  a: {
    name: 'a 100人以下',
    value: 'a'
  },
  b: {
    name: 'b 101～300人',
    value: 'b'
  },
  c: {
    name: 'c 301～500人',
    value: 'c'
  },
  d: {
    name: 'd 501～1000人',
    value: 'd'
  },
  e: {
    name: 'e 1001～5000人',
    value: 'e'
  },
  f: {
    name: 'f 5001人以上',
    value: 'f'
  }
})

export const masterClassification = Object.freeze({
  group: {
    name: 'グループ会社関連マスター',
    value: 'group'
  },
  company: {
    name: '会社関連マスター',
    value: 'company'
  },
  department: {
    name: '組織関連マスター',
    value: 'department'
  },
  empAttribute: {
    name: '従業員属性マスター',
    value: 'empAttribute'
  },
  classification: {
    name: '区分関連マスター',
    value: 'classification'
  },
  certification: {
    name: '資格関連マスター',
    value: 'certification'
  },
  dashboard: {
    name: 'ダッシュボード設定',
    value: 'dashboard'
  },
  dataMapping: {
    name: 'データマッピング関連マスター',
    value: 'dataMapping'
  },
  other: {
    name: 'その他設定',
    value: 'other'
  }
})

export const masterStatus = Object.freeze({
  notset: {
    name: '未設定',
    value: 'notset'
  },
  reflecting: {
    name: '反映中',
    value: 'reflecting'
  },
  reflected: {
    name: '反映済',
    value: 'reflected'
  },
  error: {
    name: '反映エラー',
    value: 'error'
  }
})

export const assosiationMarks = Object.freeze({
  maintain: {
    label: '維持',
    value: 'maintain'
  },
  new: {
    label: '新設',
    value: 'new'
  },
  abolish: {
    label: '廃止',
    value: 'abolish'
  },
  rename: {
    label: '名称変更',
    label_2: '名変',
    value: 'rename'
  }
})

export const genderStatisticsType = Object.freeze({
  GenderStatsAll: {
    code: '1',
    name: '全労働者'
  },
  GenderStatsRegular: {
    code: '2',
    name: '正規雇用労働者'
  },
  GenderStatsNonRegular: {
    code: '3',
    name: 'パート・有期労働者'
  },
  Excluded: {
    code: '99',
    name: '対象外'
  }
})

export const securitiesEmployeeType = Object.freeze({
  employees: {
    name: '従業員'
  },
  seasonalEmployees: {
    name: '臨時従業員'
  },
  excluded: {
    name: '対象外'
  }
})

export const fteActualWorkingHoursCalcMethodType = Object.freeze({
  workAttendance: {
    name: '勤怠データ'
  },
  approximationFactor: {
    name: '概算係数'
  }
})

export const secondmentType = Object.freeze({
  secondingCompany: {
    name: '出向元の労働者として取り扱う',
    value: '出向元'
  },
  receivingCompany: {
    name: '出向先の労働者として取り扱う',
    value: '出向先'
  }
})
